import { I18n } from '@calendly/i18n';
import { AdminIcon, UserSingleIcon } from '@calendly/ui/components/icons';
import { Item, Menu } from '@calendly/ui/components/menu';
import { BodyText } from '@calendly/ui/components/typography';
import { colorTextStandard, colorTextSecondary } from '@calendly/ui/theme';
import classNames from 'classnames';
import { useCallback, forwardRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { roleSelector } from 'features/invite_flow/selectors';
import { setRole } from 'features/invite_flow/slice';
import { isAdminOrOwnerSelector } from 'selectors/current_user';
import { useNewAdminModal } from '../use-new-admin-modal';
import { DropdownButton } from './dropdown_button';
const containerCss = "c1orqj2f";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const styledMenuIsNewAdminModalCss = "soe40s2";
const styledMenuCss = "sv4a2ot";
const StyledMenu = forwardRef((props, ref) => {
  const isNewAdminModal = useNewAdminModal();
  return <Menu ref={ref} {...props} className={classNames(styledMenuCss, {
    [styledMenuIsNewAdminModalCss]: isNewAdminModal
  }, props.className)} />;
});
const iconWrapperCss = "igr8hax";
const IconWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconWrapperCss, props.className)} />;
});
const roleInfoCss = "r1qo419l";
const RoleInfo = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(roleInfoCss, props.className)} />;
});
const roleHeadingCss = "r1uvpbjo";
const RoleHeading = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(roleHeadingCss, props.className)} />;
});
const selectedOptionCss = "sjwsa93";
const SelectedOption = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(selectedOptionCss, props.className)} />;
});
const buildRoleOptions = (isAdminOrOwner = false) => {
  const roles = [{
    description: I18n.t('publisher.add_users_modal.roles.user.description'),
    icon: <UserSingleIcon color={colorTextStandard} />,
    key: 1,
    label: I18n.t('publisher.add_users_modal.roles.user.label'),
    value: 'user'
  }];
  if (isAdminOrOwner) {
    roles.push({
      description: I18n.t('publisher.add_users_modal.roles.admin.description'),
      icon: <AdminIcon color={colorTextStandard} />,
      key: 2,
      label: I18n.t('publisher.add_users_modal.roles.admin.label'),
      value: 'admin'
    });
  }
  return roles;
};
const RoleOption = ({
  role,
  selected,
  onSelect
}) => <Item onClick={onSelect}>
    <IconWrapper>
      {role.icon}
    </IconWrapper>
    <RoleInfo>
      <RoleHeading>
        <BodyText weight="bold" size="medium">
          {role.label}
        </BodyText>
        {selected && <SelectedOption>Already selected</SelectedOption>}
      </RoleHeading>
      <BodyText color={colorTextSecondary}>
        {role.description}
      </BodyText>
    </RoleInfo>
  </Item>;
export const RoleSelect = ({
  disabled = false
}) => {
  const isAdminFlagEnabled = useNewAdminModal();
  const role = useSelector(roleSelector);
  const isAdminOrOwner = useSelector(isAdminOrOwnerSelector);
  const adminLabel = isAdminFlagEnabled ? I18n.t('publisher.add_users_modal.roles.admin.label_singular') : I18n.t('publisher.add_users_modal.roles.admin.label').toLocaleLowerCase();
  const userLabel = isAdminFlagEnabled ? I18n.t('publisher.add_users_modal.roles.user.label_singular') : I18n.t('publisher.add_users_modal.roles.user.label').toLocaleLowerCase();
  const dispatch = useDispatch();
  const onSelect = useCallback(selectedRole => {
    dispatch(setRole(selectedRole));
  }, [dispatch]);
  return <Container>
      {!isAdminFlagEnabled && <BodyText size="medium" color="muted">
        {I18n.t('publisher.add_users_modal.role_lead_text')}
      </BodyText>}
&nbsp;
      <DropdownButton label={role === 'admin' ? adminLabel : userLabel} disabled={disabled}>
        <StyledMenu>
          {buildRoleOptions(isAdminOrOwner).map(option => <RoleOption role={option} key={option.key} selected={option.value === role} onSelect={() => {
          onSelect(option.value);
        }} />)}
        </StyledMenu>
      </DropdownButton>
    </Container>;
};

require("./role_select.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./role_select.js");